import { Button, Typography } from 'mobily-ui-library/lib';
import Modal from '../Modal/Modal';
import './RegConfirmModal.scss';
import { useTranslation } from 'react-i18next';

interface Props {
    id?: string;
    rtl?: boolean;
    modalFirstButtonClick?: () => void;
    handleHeaderCancel?: () => void;
}

function RegConfirmModal({ rtl, id, modalFirstButtonClick, handleHeaderCancel }: Props) {
    const { t } = useTranslation();

    return (
        <Modal className={'Register__modal'} handleHeaderCancel={handleHeaderCancel} id={id} rtl={rtl}>
            <Typography rtl={rtl} className='CC__MST mb-0 lh-sm' fontFamily='ScandiaWeb-Medium'>{t('There_no_coverage')} </Typography>
            <Typography rtl={rtl} className='CC__MST' fontFamily='ScandiaWeb-Medium'>{t('Register_your_interest_req_coverage')} </Typography>
            <Button rtl={rtl} className='CC__MButton' onClick={modalFirstButtonClick}>{t('REGISTER_INTEREST')}</Button>
        </Modal>
    )
}

export default RegConfirmModal